/**
 * The draft link the edit bar's *See it in your draft* opens (ADR-0032 §6: a
 * new tab showing what is saved, never an inline preview).
 *
 * The firm's one standing preview link (C6, ADR-0024) is on every read of the
 * site, which `SiteProvider` makes for everything under `/site`. Outside it —
 * or when the link is off or lapsed — there is no link and the bar shows none.
 */

import { type PreviewLink, previewUrl } from '../../lib/api/site'
import { useOptionalSite } from '../../routes/Site/useSite'

/** Pure: the absolute address of the draft, or `null`. */
export function draftPreviewHref(preview: Pick<PreviewLink, 'path'> | null | undefined): string | null {
  return previewUrl(preview?.path ?? null)
}

/** The draft preview's address for the page being edited, from `useSite`. */
export function useDraftPreviewHref(): string | null {
  const site = useOptionalSite()
  return draftPreviewHref(site?.preview)
}
